module.exports = __webpack_public_path__ + "static/info-watch-logo-0a5df799e825645cc2b693e8e1be2f85.png";